export const userHeading = [
  { header: "Name", accessor: "name" },
  { header: "User Code", accessor: "code" },
  { header: "Contact", accessor: "contactDetails" },
  { header: "Role", accessor: "type" },
  { header: "Status", accessor: "status" },
];
